// LoginPage.tsx
import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import MainHeader from "../pages/MainHeader";
import { useNavigate } from "react-router-dom";
import { routes } from "../routes/routes-names";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { authService } from "../lib/api/auth";
import { tokenManager } from '../lib/token-manager';
import { LocalStorageManager } from '../lib/localStorage-manager';
import Swal from "sweetalert2";

const tsmclogo = require("../assets/images/TSMC_LOGO.jpg");
const AdminLogin: React.FC = () => {
  const navigate = useNavigate();

  const initialValues = {
    username: "",
    password: ""

  };
const [loading, setLoading] = useState(false);
  const validationSchema = Yup.object({
    username: Yup.string().required("User Name is required"),
    password: Yup.string().min(4, "Min 4 characters").required("Password is required"),

  });

  
  const handleSubmit = async (values: typeof initialValues) => {

    setLoading(true);
    try {
      const {token, success,username } = await authService.adminLogin({
        username: values.username,
        password: values.password,
      });


      if (success) {
        setLoading(false);
        tokenManager.removeToken();
        tokenManager.setToken(token);
        LocalStorageManager.removeUserName();
        username&&LocalStorageManager.setUserName(username);
        navigate(routes.adminLayout); // go to org layout
      } else {
        setLoading(false);
        Swal.fire({
          title: "Error",
          text: "Failed to Login",
          icon: "error",
          confirmButtonText: "OK",
        })
      }

    } catch (err) {
      setLoading(false);
      Swal.fire({
          title: "Error",
          text: "Failed to Login",
          icon: "error",
          confirmButtonText: "OK",
        })
      console.log('error in organization creation', err);
    }
  }



  return (<>
    <MainHeader />

    <div className="login-page-wrap d-flex align-items-center justify-content-center">
      <div className="row w-100 shadow rounded bg-white" style={{ maxWidth: "900px" }}>

        {/* Left Side - Scrolling Events */}
        <div className="col-md-6 border-end d-flex flex-column">
        <div className="col login-left-panel text-white">
            <img src={tsmclogo} alt="Logo" style={{ width: "400px", margin:"20px" }} height={400} className="me-2" />
        </div>
        </div>

        {/* Right Side - Login Form */}
        <div className="col-md-6 p-5 d-flex flex-column justify-content-center">
          <div className="text-center mb-4">
            <img src={tsmclogo} alt="Logo" style={{ width: "80px" }} height={40} className="me-2" />
            <h4 className="mt-2 cme-header">Admin Login</h4>
          </div>

          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            <Form>
              {/* Email */}
              <div className="mb-3">
                <label className="form-label">Admin User</label>
                <Field
                  name="username"
                  type="text"
                  className="form-control"
                  placeholder="Enter Username"
                />
                <ErrorMessage name="username" component="div" className="text-danger small" />
              </div>

              {/* Password */}
              <div className="mb-3">
                <label className="form-label">Password</label>
                <Field
                  name="password"
                  type="password"
                  className="form-control"
                  placeholder="Enter password"
                />
                <ErrorMessage name="password" component="div" className="text-danger small" />
              </div>
                <button type="submit" className="btn-submit w-100"
                         disabled={loading} >
                          {loading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Logging in...
                  </>
                ) : (
                  "Login"
                )}
                </button>
            </Form>
          </Formik>
        </div>
      </div>
    </div>
  </>
  );
};

export default AdminLogin;
